import React from 'react';

import { Text } from '@reckon-web/text';

import { ActivityTargetValue } from '../activities-types';
import { getTargetType } from '../helper';

interface IActivityCategoryReopened {
  activityTarget: ActivityTargetValue;
}
// ActivityCategory Reopened = 14
export const ActivityCategoryReopened = ({
  activityTarget,
}: IActivityCategoryReopened) => (
  <Text size="small">Reopened this {getTargetType(activityTarget)}</Text>
);
